export default __webpack_public_path__ + "static/media/Driftwood.01e47b5b.jpg";